import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";

import { getFileExtensionFromUrl } from "../../../helpers";
import { ITrialBalance } from "./TrialBalance.types";

export const FETCH_TRIAL_BALANCE_LIST_PROGRESS =
  "FETCH_TRIAL_BALANCE_LIST_PROGRESS";
export const FETCH_TRIAL_BALANCE_LIST_SUCCESS =
  "FETCH_TRIAL_BALANCE_LIST_SUCCESS";
export const FETCH_TRIAL_BALANCE_LIST_FAILED =
  "FETCH_TRIAL_BALANCE_LIST_FAILED";

export const fetchTrialBalanceListProgress = () =>
  action(FETCH_TRIAL_BALANCE_LIST_PROGRESS);
export const fetchTrialBalanceListSuccess = (
  data: ITrialBalance[],
  totalRecords: number
) =>
  action(FETCH_TRIAL_BALANCE_LIST_SUCCESS, { data, totalRecords });
export const fetchTrialBalanceListFailed = () =>
  action(FETCH_TRIAL_BALANCE_LIST_FAILED);

export const fetchTrialBalanceListAsync =
  (
    status: string,
    isZeroInclude: boolean,
    searchState: { [key: string]: any }
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const { month, year, to_date  } = searchState;
      dispatch(fetchTrialBalanceListProgress());
       let finalUrl = `/accounting/get-trail-balance-sheet?to_date=${to_date}`;
      //let finalUrl = `/accounting/get-trail-balance-sheet?month=${month}&year=${year}`;
      // if(isZeroInclude){
      //   finalUrl += "&isZeroInclude=" + isZeroInclude
      // }

      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }

      const res = await api.get(finalUrl);
      const data: ITrialBalance[] = res.data.data.trialBalance;
      const totalRecords = res.data.data.trialBalance.length;

      dispatch(fetchTrialBalanceListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchTrialBalanceListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const fetchTrialBalanceListForExportAsync =
  (
    searchState: { [key: string]: any },
    userId: number,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
        const { to_date } = searchState;
      dispatch(saveLoaderProgress());

      const finalUrl = `/accounting/get-trail-balance-sheet-pdf?to_date=${to_date}&user_id=${userId}`;

      // if (from_date) {
      //   const filterObj = {
      //     column: ["date"],
      //     operator: "GREATER_THAN_EQUAL",
      //     value: from_date,
      //     logicalOperator: "AND",
      //   };

      //   const encodedFilter = encodeURIComponent(
      //     JSON.stringify(filterObj, null, 2)
      //   );
      //   finalUrl += `&advanceFilter=${encodedFilter}`;
      // }
      // if (to_date) {
      //   const filterObj = {
      //     column: ["date"],
      //     operator: "LESSER_THAN_EQUAL",
      //     value: to_date,
      //     logicalOperator: "AND",
      //   };

      //   const encodedFilter = encodeURIComponent(
      //     JSON.stringify(filterObj, null, 2)
      //   );
      //   finalUrl += `&advanceFilter=${encodedFilter}`;
      // }

      const res = await api.get(finalUrl, {
        responseType: "arraybuffer",
      });

      const blob = new Blob([res.data], {
        type: "application/" + getFileExtensionFromUrl("Balance_sheet.pdf"),
      });
      // const blob = new Blob([res.data], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);

      // Create a link element and simulate a click to trigger the download
      const link = document.createElement("a");
      link.href = url;
     link.setAttribute("download", "Balance_sheet.pdf");// Set the desired file name and extension
      document.body.appendChild(link);
      link.click();

      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_TRIAL_BALANCE = "CLEAR_TRIAL_BALANCE";
export const clearTrialBalances = () =>
  action(CLEAR_TRIAL_BALANCE);
